import React from "react";
import SEO from "../components/SEO";
import seoData from "../seoData";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import { Internship } from "../components/internship";
import JsonData from "../data/data.json";

const InternshipPage = () => {
  return (
    <>
        {/* SEO Meta */}
        <SEO {...seoData.internship} />
        <BreadcrumbSchema
            items={[
                { name: "Home", url: "/" },
                { name: "Internship", url: "/internship" },
            ]}
        />
        <Internship data={JsonData.Internship} />
    </>
  );
};

export default InternshipPage;
